import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { toast } from 'react-hot-toast';
import { GET_VISITOR_BY_ID_API, UPDATE_VISITOR_APPROVAL_API } from '../utils/api';

function VisitorApprovalConfirm() {
  const [searchParams] = useSearchParams();
  const visitorId = searchParams.get('id');
  const createdAt = searchParams.get('timestamp');

  const [visitor, setVisitor] = useState(null);
  const [remark, setRemark] = useState('');
  const [materials, setMaterials] = useState({
    laptop: false,
    mobile: false,
    tools: false
  });

  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (visitorId && createdAt) fetchVisitor();
  }, [visitorId, createdAt]);

  const fetchVisitor = async () => {
    try {
      const res = await axios.post(GET_VISITOR_BY_ID_API, {
        visitor_id: visitorId,
        created_at: createdAt,
        token
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        setVisitor(res.data.visitor);
      } else {
        toast.error(res.data.message || 'Visitor not found');
      }
    } catch {
      toast.error('Error fetching visitor data');
    }
  };

  const handleDecision = async (decision) => {
    try {
      const res = await axios.post(UPDATE_VISITOR_APPROVAL_API, {
        visitor_id: visitorId,
        created_at: createdAt,
        action: decision,
        approval_remark: remark,
        allow_laptop: materials.laptop ? 1 : 0,
        allow_mobile: materials.mobile ? 1 : 0,
        allow_tools: materials.tools ? 1 : 0,
        token
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (res.data.success) {
        toast.success(`Visitor ${decision}ed successfully`);
        navigate('/visitor-approval');
      } else {
        toast.error(res.data.message || 'Update failed');
      }
    } catch {
      toast.error('Server error during update');
    }
  };

  const handleCheckboxChange = (field) => {
    setMaterials((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  return (
    <>
      <Navbar />
      <div className="container py-4">
        <div className="card shadow-lg border-0 p-4 rounded-4">
          <h3 className="text-center mb-4 fw-bold text-primary">🪪 Visitor Gate Pass Approval</h3>

          {!visitor ? (
            <div className="text-center my-5">Loading visitor details...</div>
          ) : (
            <>
              {/* Visitor Photo */}
             
              {/* Visitor Info */}
              <h5 className="mb-3 border-bottom pb-2 text-secondary">🔎 Visitor Details</h5>
             {/* Visitor Info + Photo in 3 columns */}
<div className="row mb-4">


  <div className="col-md-4 text-center">
    {visitor.visitor_photo && (
      <>
        <img
          src={`data:image/jpeg;base64,${visitor.visitor_photo}`}
          alt="Visitor"
          width={200}
          height={200}
          style={{
            objectFit: 'cover',
            borderRadius: '12px',
            border: '3px solid #ddd',
            boxShadow: '0 0 8px rgba(0,0,0,0.1)'
          }}
        />
        <p className="mt-2 text-dark fs-4">{visitor.name}</p>
      </>
    )}
  </div>
  {/* Column 1 */}
  <div className="col-md-4">
    <div className="mb-3"><strong>Name:</strong> {visitor.name} - ({visitor.sex})</div>
    <div className="mb-3"><strong>Mobile:</strong> {visitor.mobile}</div>
    <div className="mb-3"><strong>Company:</strong> {visitor.company}, {visitor.company_address}, {visitor.city}, {visitor.pincode}</div>
  </div>

  {/* Column 2 */}
  <div className="col-md-4">
    <div className="mb-3"><strong>Date of Birth:</strong> {visitor.birth_date}</div>
    <div className="mb-3"><strong>Visitor Type:</strong> {visitor.visitor_type_name}</div>
    <div className="mb-3"><strong>Purpose:</strong> {visitor.visit_purpose_name}</div>
    <div className="mb-3"><strong>Entered By:</strong> {visitor.created_by_name} - {visitor.created_at}</div>
  </div>

  {/* Column 3 - Visitor Photo */}
  
</div>


              {/* Material Allowance */}
              <h5 className="mt-4 border-bottom pb-2 text-secondary">📦 Materials Allowed</h5>
              <div className="bg-light p-3 rounded mb-3">
                {['laptop', 'mobile', 'tools'].map((item) => (
                  <div className="form-check form-check-inline me-4" key={item}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`${item}Check`}
                      checked={materials[item]}
                      onChange={() => handleCheckboxChange(item)}
                    />
                    <label className="form-check-label" htmlFor={`${item}Check`}>
                      {item.charAt(0).toUpperCase() + item.slice(1)}
                    </label>
                  </div>
                ))}
              </div>

              {/* Remarks */}
              <div className="mb-4">
                <label className="form-label"><strong>📝 Approval Remark (optional):</strong></label>
                <textarea
                  className="form-control"
                  rows={3}
                  placeholder="Enter any additional remarks"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>

              {/* Action Buttons */}
              <div className="d-flex flex-wrap gap-3 justify-content-center mt-4">
                <button className="btn btn-success px-4" onClick={() => handleDecision('approve')}>✅ Approve</button>
                <button className="btn btn-danger px-4" onClick={() => handleDecision('reject')}>❌ Reject</button>
                <button className="btn btn-outline-secondary px-4" onClick={() => navigate('/visitor-approval')}>← Back</button>
              </div>

              {/* Signature Block */}
              <div className="text-end mt-5">
                <p className="mb-1"><strong>Signature of Approver</strong></p>
                <div style={{ borderBottom: '1px solid #333', width: '200px', marginLeft: 'auto' }}></div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default VisitorApprovalConfirm;
